import React, { useState } from 'react'
import { CNav, CNavItem, CNavLink, CTabContent, CTabPane, CRow } from '@coreui/react'
import ContentReport from './contentReport'
import UserContentReport from './userContentReport'

const ContentAnalytics = () => {
  const [activePane, setActivePane] = useState(1)

  const activeTab = { color: '#1976d2', fontSize: '1.1rem', cursor: 'pointer' }
  const inActiveTab = { color: '#191818', fontSize: '1.1rem', cursor: 'pointer' }
  return (
    <div className="">
      <h2>Content Analytics</h2>
      <CRow className="mt-3">
        <CNav variant="tabs">
          <CNavItem>
            <CNavLink
              className="px-5"
              style={activePane === 1 ? activeTab : inActiveTab}
              active={activePane === 1}
              onClick={() => setActivePane(1)}
            >
              {`Content Report`}
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              className="px-5"
              style={activePane === 2 ? activeTab : inActiveTab}
              active={activePane === 2}
              onClick={() => setActivePane(2)}
            >
              User Content Report
            </CNavLink>
          </CNavItem>
        </CNav>
        <CTabContent>
          <CTabPane role="tabpanel" visible={activePane === 1}>
            <CRow>
              <ContentReport />
            </CRow>
          </CTabPane>
          <CTabPane role="tabpanel" visible={activePane === 2}>
            <CRow>
              <UserContentReport />
            </CRow>
          </CTabPane>
        </CTabContent>
      </CRow>
    </div>
  )
}

export default ContentAnalytics
